/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import type {
  BodyGetDataCountClickhouseGetDataCountPost,
  BodyGetGroupedDataClickhouseGetGroupedDataPost,
  BodyMigrateDashboardReqClickhouseMigrateDashboardPost,
  BodyMigrateInvoicesClickhouseMigrateInvoicesPost,
  BodyMigratePurchaseOrdersClickhouseMigratePurchaseOrdersPost,
  BodyRunBasicQueryClickhouseRunBasicQueryPost,
  BodyRunCommandClickhouseRunCommandPost,
  BodyRunComplexQueryClickhouseRunComplexQueryPost,
  DashboardClickhouseDashboardGetParams,
  SupplierStatisticsClickhouseSupplierStatisticsGetParams,
} from '.././models';

import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getClickhouse = () => {
  /**
   * @summary Get Data Count
   */
  const getDataCountClickhouseGetDataCountPost = (
    bodyGetDataCountClickhouseGetDataCountPost: BodyGetDataCountClickhouseGetDataCountPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetDataCountClickhouseGetDataCountPost.org_id,
    );
    formUrlEncoded.append(
      `group_by`,
      bodyGetDataCountClickhouseGetDataCountPost.group_by,
    );
    formUrlEncoded.append(
      `table`,
      bodyGetDataCountClickhouseGetDataCountPost.table,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/get_data_count`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Grouped Data
   */
  const getGroupedDataClickhouseGetGroupedDataPost = (
    bodyGetGroupedDataClickhouseGetGroupedDataPost: BodyGetGroupedDataClickhouseGetGroupedDataPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetGroupedDataClickhouseGetGroupedDataPost.org_id,
    );
    bodyGetGroupedDataClickhouseGetGroupedDataPost.data_list.forEach((value) => formUrlEncoded.append(`data_list`, String(value)),
    );
    formUrlEncoded.append(
      `table`,
      bodyGetGroupedDataClickhouseGetGroupedDataPost.table,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/get_grouped_data`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Run Basic Query
   */
  const runBasicQueryClickhouseRunBasicQueryPost = (
    bodyRunBasicQueryClickhouseRunBasicQueryPost: BodyRunBasicQueryClickhouseRunBasicQueryPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyRunBasicQueryClickhouseRunBasicQueryPost.org_id,
    );
    bodyRunBasicQueryClickhouseRunBasicQueryPost.data_list.forEach((value) => formUrlEncoded.append(`data_list`, String(value)),
    );
    formUrlEncoded.append(
      `table`,
      bodyRunBasicQueryClickhouseRunBasicQueryPost.table,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/run_basic_query`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Run Complex Query
   */
  const runComplexQueryClickhouseRunComplexQueryPost = (
    bodyRunComplexQueryClickhouseRunComplexQueryPost: BodyRunComplexQueryClickhouseRunComplexQueryPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyRunComplexQueryClickhouseRunComplexQueryPost.org_id,
    );
    bodyRunComplexQueryClickhouseRunComplexQueryPost.data_list.forEach((value) => formUrlEncoded.append(`data_list`, String(value)),
    );
    formUrlEncoded.append(
      `table`,
      bodyRunComplexQueryClickhouseRunComplexQueryPost.table,
    );
    if (
      bodyRunComplexQueryClickhouseRunComplexQueryPost.conditions !== undefined
    ) {
      bodyRunComplexQueryClickhouseRunComplexQueryPost.conditions.forEach(
        (value) => formUrlEncoded.append(`conditions`, JSON.stringify(value)),
      );
    }
    formUrlEncoded.append(
      `group_by`,
      bodyRunComplexQueryClickhouseRunComplexQueryPost.group_by,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/run_complex_query`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Run Command
   */
  const runCommandClickhouseRunCommandPost = (
    bodyRunCommandClickhouseRunCommandPost: BodyRunCommandClickhouseRunCommandPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyRunCommandClickhouseRunCommandPost.org_id,
    );
    formUrlEncoded.append(
      `command`,
      bodyRunCommandClickhouseRunCommandPost.command,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/run_command`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Dashboard
   */
  const dashboardClickhouseDashboardGet = (
    params?: DashboardClickhouseDashboardGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/clickhouse/dashboard`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Migrate Dashboard Req
   */
  const migrateDashboardReqClickhouseMigrateDashboardPost = (
    bodyMigrateDashboardReqClickhouseMigrateDashboardPost: BodyMigrateDashboardReqClickhouseMigrateDashboardPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyMigrateDashboardReqClickhouseMigrateDashboardPost.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/clickhouse/migrate_dashboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Migrate Invoices
   */
  const migrateInvoicesClickhouseMigrateInvoicesPost = (
    bodyMigrateInvoicesClickhouseMigrateInvoicesPost: BodyMigrateInvoicesClickhouseMigrateInvoicesPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (bodyMigrateInvoicesClickhouseMigrateInvoicesPost.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodyMigrateInvoicesClickhouseMigrateInvoicesPost.org_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/clickhouse/migrate_invoices`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Migrate Purchase Orders
   */
  const migratePurchaseOrdersClickhouseMigratePurchaseOrdersPost = (
    bodyMigratePurchaseOrdersClickhouseMigratePurchaseOrdersPost: BodyMigratePurchaseOrdersClickhouseMigratePurchaseOrdersPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodyMigratePurchaseOrdersClickhouseMigratePurchaseOrdersPost.org_id !==
      undefined
    ) {
      formUrlEncoded.append(
        `org_id`,
        bodyMigratePurchaseOrdersClickhouseMigratePurchaseOrdersPost.org_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/clickhouse/migrate_purchase_orders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * Get supplier statistics including OTIF, delayed shipments, delayed value, and average lateness days
   * @summary Supplier Statistics
   */
  const supplierStatisticsClickhouseSupplierStatisticsGet = (
    params: SupplierStatisticsClickhouseSupplierStatisticsGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/clickhouse/supplier_statistics`,
      method: 'GET',
      params,
    });
  };
  return {
    getDataCountClickhouseGetDataCountPost,
    getGroupedDataClickhouseGetGroupedDataPost,
    runBasicQueryClickhouseRunBasicQueryPost,
    runComplexQueryClickhouseRunComplexQueryPost,
    runCommandClickhouseRunCommandPost,
    dashboardClickhouseDashboardGet,
    migrateDashboardReqClickhouseMigrateDashboardPost,
    migrateInvoicesClickhouseMigrateInvoicesPost,
    migratePurchaseOrdersClickhouseMigratePurchaseOrdersPost,
    supplierStatisticsClickhouseSupplierStatisticsGet,
  };
};
export type GetDataCountClickhouseGetDataCountPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getClickhouse>['getDataCountClickhouseGetDataCountPost']
    >
  >
>;
export type GetGroupedDataClickhouseGetGroupedDataPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getClickhouse
      >['getGroupedDataClickhouseGetGroupedDataPost']
    >
  >
>;
export type RunBasicQueryClickhouseRunBasicQueryPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getClickhouse
      >['runBasicQueryClickhouseRunBasicQueryPost']
    >
  >
>;
export type RunComplexQueryClickhouseRunComplexQueryPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getClickhouse
      >['runComplexQueryClickhouseRunComplexQueryPost']
    >
  >
>;
export type RunCommandClickhouseRunCommandPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getClickhouse>['runCommandClickhouseRunCommandPost']
    >
  >
>;
export type DashboardClickhouseDashboardGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getClickhouse>['dashboardClickhouseDashboardGet']
    >
  >
>;
export type MigrateDashboardReqClickhouseMigrateDashboardPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getClickhouse
        >['migrateDashboardReqClickhouseMigrateDashboardPost']
      >
    >
  >;
export type MigrateInvoicesClickhouseMigrateInvoicesPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getClickhouse
      >['migrateInvoicesClickhouseMigrateInvoicesPost']
    >
  >
>;
export type MigratePurchaseOrdersClickhouseMigratePurchaseOrdersPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getClickhouse
        >['migratePurchaseOrdersClickhouseMigratePurchaseOrdersPost']
      >
    >
  >;
export type SupplierStatisticsClickhouseSupplierStatisticsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getClickhouse
        >['supplierStatisticsClickhouseSupplierStatisticsGet']
      >
    >
  >;
